export default __webpack_public_path__ + "static/media/js-icon.0c0133e3.svg";